import React, { useState, useEffect, useCallback } from 'react';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { TableSearchInput } from './GasGraphSearchBar.css.js';
import { firstWeekMap } from 'utils/code';

const SearchPeriod = ({ updateSearchMap, setDateValid }) => {
  const cancellationToken = useCancellationToken();
  const [ option, setOption ] = useState('custom');
  const [ year, setYear ] = useState((new Date()).getFullYear());
  const [ quarter, setQuarter ] = useState(1);
  const [ month, setMonth ] = useState(1);
  const [ week, setWeek ] = useState(1);

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return
    }

    setDateValid(option === 'custom');
  }, [option])

  useEffect(() => {
    if (cancellationToken.isCancelled || option === 'custom') {
      return;
    }

    const [ beginDate, endDate ] = setDate();
    updateSearchMap('beginDate', new Date(beginDate));
    updateSearchMap('endDate', new Date(endDate));
  }, [year, quarter, month, week, option]);

  const setDate = useCallback(() => {
    if (option === 'year') {
      return [`${year}-01-01 00:00:00`,
              `${year}-12-31 24:00:00`];
    }
    else if (option === 'quarter') {
      return [`${year}-${1 + 3 * (quarter - 1)}-01 00:00:00`,
              `${year}-${3 * quarter}-31 24:00:00`];
    }
    else if (option === 'month') {
      return [`${year}-${month}-01 00:00:00`,
              `${year}-${month}-31 24:00:00`];
    }
    else if (option === 'week') {
      const firstDate = new Date(`${year}-${month}-01`);
      const lastDate = new Date(year, month, 0);

      const firstWeekDayCounts = firstWeekMap[firstDate.getDay()];
      const begin = week === 1 ? 1 : 1 + firstWeekDayCounts + 1 + 7 * (week - 2);
      const end = week === 5 ? lastDate.getDate() : 1 + firstWeekDayCounts + 7 * (week - 1);

      return [`${year}-${month}-${begin > lastDate.getDate() ? lastDate.getDate() : begin} 00:00:00`,
              `${year}-${month}-${end > lastDate.getDate() ? lastDate.getDate() : end} 24:00:00`];
    }
  }, [year, quarter, month, week, option])

  useEffect(() => () => cancellationToken.cancel(), []);

  return (
    <div className={`search-condition col-xl-5 col-sm-6`}>
      <label>기간설정</label>
      <TableSearchInput className="up-check"
                        option={option}
                        onChange={(({target}) => setOption(target.value))}>
        <option value='custom'>사용자 지정</option>
        <option value='year'>연간</option>
        <option value='quarter'>분기간</option>
        <option value='month'>월간</option>
        <option value='week'>주간</option>
      </TableSearchInput>
      
      <TableSearchInput className="up-check"
                        onChange={(({target}) => setYear(Number(target.value)))}
                        option={option}
                        style={{display: option !== 'custom' ? 'block' : 'none'}}>
        {
          [...Array(15).keys()].map((v) => {
            return <option value={(new Date()).getFullYear() - v} key={"year_" + v}>{(new Date()).getFullYear() - v}년</option>
          })
        }
      </TableSearchInput>

      <TableSearchInput className="up-check"
                        onChange={(({target}) => setQuarter(Number(target.value)))}
                        option={option}
                        style={{display: option === 'quarter' ? 'block' : 'none'}}>
        {
          [...Array(4).keys()].map((v) => {
            return <option value={v + 1} key={"quarter_" + v}>{v + 1}사분기</option>
          })
        }
      </TableSearchInput>

      <TableSearchInput className="up-check"
                        onChange={(({target}) => setMonth(Number(target.value)))}
                        option={option}
                        style={{display: option === 'month' || option === 'week' ? 'block' : 'none'}}>
        {
          [...Array(12).keys()].map((v) => {
            return <option value={v + 1} key={"month_" + v}>{v + 1}월</option>
          })
        }
      </TableSearchInput>

      <TableSearchInput className="up-check"
                        onChange={(({target}) => setWeek(Number(target.value)))}
                        option={option}
                        style={{display: option === 'week' ? 'block' : 'none'}}>
        {
          [...Array(5).keys()].map((v) => {
            return <option value={v + 1} key={"week_" + v}>{v + 1}주차</option>
          })
        }
      </TableSearchInput>
    </div>
  )
}

export default SearchPeriod;